export const useEventStartFiltersConsts = {
	EVENT_START_FILTER_SEARCH_PARAM: 'filter',
	EVENT_START_FILTER_ALL: 'all',
};
